import React from 'react';
import styled from 'styled-components';
import textTypes from './_styled/text.styled';

const StyledText = styled(({ tag, type, ...props }) => {
  const CustomTag = tag || textTypes.tagMap[type];

  if (!CustomTag || !textTypes.styles[type]) {
    // eslint-disable-next-line no-console
    //console.error(`Text type '${type}' does not exist`);        
    type = "bodySm";
  }

  return <CustomTag {...props} />;
})`
  ${({ type }) => textTypes.styles[type]};
`;

function Text({ tag, children, text, type, ...otherProps }) {
  const TextContent = text || children;  
  return <StyledText tag={tag} type={type} {...otherProps}>{TextContent}</StyledText>;
}

export default Text;